import HOOK from "../components/hooks"
import { setNodeAngles } from './setNodeAngles'
import { CATEGORY, CONSTANTS, KINSHIP, LINKS, TENSE_ENUM } from '../modules/constants'
import { CHECKBOX } from '../modules/checkbox_constants'
import { getChecked } from "../pages/companiesHouse/pageFunctions/checkboxFunctions"

export const committeesDataPrep = {

  getConnectedNodes: props => {
    // console.log('getConnectedNodes props:', props)
    const { entities, features, hubId } = props
    const existingNodeIds = [hubId]

    // level 0 - hub node (level 0)
    let level0Entity = entities.items[hubId]
    level0Entity.showPosition = features.EnablePosition

    // Initialise node array with the hub node
    const nodes = [{
      level: 0,
      entity: level0Entity,
      id: level0Entity.entityId,
      filings: getFilingsArray(level0Entity.companyFilingHistory),
    }]

    // console.log('nodes:', nodes)
    // level 1 - nodes and their connections from hub
    const zeroCommitteeNodes = setNodes(
      {
        ...props,
        connectionIds: level0Entity.connectionIds,
        existingNodeIds,
        level: 1,
        nodes,
        thisNodeId: hubId,
      })

    // 'total' is the total number of current (and futures) nodes before and other filters.
    // Required to extablish correct 'NoDataMessage'
    return { committeesNodes: nodes, zeroCommitteeNodes }
  },

  sortNodes: props => {
    const { nodes } = props

    // sort by level
    nodes.sort((a, b) => levelIsGreaterThen(a, b) ? 1 : levelIsGreaterThen(b, a) ? -1 : 0)

    if (CONSTANTS.ENABLE_INITIAL_POSITIONS)
      setNodeAngles(props) // must be done after sorting nodes
  },
}

const levelIsGreaterThen = (m, n) => m.entity.level > n.entity.level

// Returns true if companyProps.lse is null and OTHER_INDEX
// is checked, or if companyProps.lse.indexBit (inc. aic) is checked
const isIndexSelected = ({ checkboxes, entity }) => {
  const { companyProps } = entity

  return entity.category === CATEGORY.PERSON
    ? true
    : !!companyProps?.lse?.indexBit
      ? !!(checkboxes[HOOK.LSE_INDEX] & companyProps.lse?.indexBit) &&
      ((getChecked({ checkboxes, hook: HOOK.COMPANY_TYPE })[0] && !companyProps.lse.aic) ||
        (getChecked({ checkboxes, hook: HOOK.COMPANY_TYPE })[1] && companyProps.lse.aic))
      : getChecked({ checkboxes, hook: HOOK.OTHER_INDEX })[0]
}

// For RADIO[BASE.COMPANY].DASHBOARD we will filter roles by current and outgoing tense
const currentAndOutgoingBits = CHECKBOX[HOOK.TENSE][TENSE_ENUM.CURRENT].BIT | CHECKBOX[HOOK.TENSE][TENSE_ENUM.NOTICE].BIT

const setNodes = props => {
  // console.log('setNodes props:', props)
  const { checkboxes, connectionIds, entities, existingNodeIds, level, nodes, thisNodeId } = props
  const nodeIds = []
  const checked = { sex: getChecked({ checkboxes, hook: [HOOK.SEX] }) }
  // console.log('nodes:',nodes)
  let totalNodes = 0
  for (var id in connectionIds) {
    const thisConnection = entities.connections[connectionIds[id]]
    // determine whether the parent or the child is this node
    let connectedEntity = thisConnection.parentId === thisNodeId
      ? entities.items[thisConnection.childId]
      : entities.items[thisConnection.parentId]

    // check if node for this connected entity already exists
    let connectedNodeExists = existingNodeIds.some(id => id === connectedEntity.entityId)

    // NB: position is passed as ref. and it's props are assigned via anyCapacities
    const position = { tense: null, tenseBits: 0, typeBits: 0, total: 0 }
    thisConnection.capacities && anyCapacities({ ...props, thisConnection, position, currentAndOutgoingBits })
    connectedEntity.position = position

    totalNodes += position.total

    if (isIndexSelected({ checkboxes, entity: connectedEntity })) {

      // If not an lse company, we generally won't know gender so show regardless of sex
      const sexSelected = isSexSelected(connectedEntity, checked)

      if (!connectedNodeExists  // only create node if it does not already exist,
        && position.show // add node only if it has a role with tense and position selected
        && sexSelected // and sex selected
      ) {
        nodeIds.push(connectedEntity.entityId)
        existingNodeIds.push(connectedEntity.entityId)
        if (level < 3)
          setNode(
            {
              nodes,
              entity: connectedEntity,
              lConnectId: thisNodeId,
              level,
              tense: position.tense,
              tenseBits: position.tenseBits,
              kinship: thisConnection.parentId === thisNodeId
                ? KINSHIP.CHILD
                : KINSHIP.PARENT,
            })
      }
    }
  }

  return totalNodes === 0
}

const setNode = ({ nodes, entity, lConnectId, level, kinship, tense, tenseBits }) => {
  nodes.push({
    level,
    entity,
    id: entity.entityId,
    tense,
    tenseBits,
    filings: level === 0 ? getFilingsArray(entity.companyFilingHistory) : [],
    lConnectId,
    kinship,
  })
}

// Return true if sex is selected or it's a company
const isSexSelected = (entity, checked) => entity.category === CATEGORY.COMPANY
  ? true // Return true it's a company, so sex is irrelevant
  : entity.personInfo.sex === null
    ? checked.sex[2] // Return: is 'sex unknown' checked?
    : checked.sex[entity.personInfo.sex] // Return: is the person's sex checked?

const getFilingsArray = filingHistory => filingHistory
  ? filingHistory.items.map(item => ({
    // documentMetaDataLink: item.links.documentMetaData,
    pdfLink: item.resources.applicationPdf
      ? `${LINKS.COMPANIES_HOUSE}${item.links.self}/document?format=pdf`
      : null,
    xhtmlLink: item.resources.applicationXhtml
      ? `${LINKS.COMPANIES_HOUSE}${item.links.self}/document?format=xhtml`
      : null,
    // filingDescription: item.description,
    // descriptionToPresent: item.descriptionToPresent,
  }))
  : []

const anyCapacities = props => {
  const { thisConnection, position, currentAndOutgoingBits } = props

  const id = thisConnection.childId
  position.show = false

  for (var capacity in thisConnection.capacities) {
    anyRoles({ ...props, roles: thisConnection.capacities[capacity], id, currentAndOutgoingBits })
  }
  return
}

const anyRoles = props => {
  // console.log('anyRoles props:', props)
  const { checkboxes, features, position, roles } = props

  var role
  for (let i = 0; i < roles.length; ++i) {

    if (roles[i].cmtes !== null) {
      role = roles[i]
      // console.log('role:', role)
      // tenseBits is an accumulation of the different roles an officer may have
      position.tenseBits = position.tenseBits | role.tenseBit

      role.typeBit = CHECKBOX[HOOK.POSITION][role.position.type].BIT // TODO defined typeBit in backend
      // typeBits is an accumulation of the different role types an officer may have
      position.typeBits = position.typeBits | role.typeBit

      // If position.tense is current or outgoing ( bit (1 | 2))
      // and the role is displayed
      if (!!(position.tenseBits & 3)) {
        position.total++ // increment the total before filtering by type checkbox
        position.tense = role.tense

        if (role.position) {
          position.type = role.position.type // We need the type so that we can filter eg secretaries..
          if (features.EnablePosition)
            position.name = role.position.title // but don't show the title (eg 'Chairman') if not features.EnablePosition
        }

        role.show =
          !!(checkboxes[HOOK.POSITION] & role.typeBit) &&
          !!(checkboxes[HOOK.EXEC] & getBit(role.position.exec)) &&
          !!(checkboxes[HOOK.INDP] & getBit(role.position.independent))
      }

      if (role.show) position.show = true
    }
  }
}

// Returns 1 if bool is true, 2 if false, or 4 if null
const getBit = bool => bool == true ? 1 : bool === false ? 2 : 4

